













import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ContextMenu from "@share/web-conferences/components/common/ContextMenu.vue";
import { ContextButtonPosition } from "@share/web-conferences/enums/ContextButtonPosition";

@Component({
  name: "ButtonWithContext",
  components: {ContextMenu}
})
export default class ButtonWithContext extends Vue {
  @Prop({ default: ContextButtonPosition.TopMiddle}) position: ContextButtonPosition;
  @Prop({default: false}) isFluent: boolean;
  @Prop({default: false}) hideAfterSelect: boolean;
  @Prop({default: false}) disabled: boolean;
  @Prop({default: false}) disableClick: boolean;
  @Prop({default: false}) buttonMode: boolean;

  showContext = false;
  shift = 0;

  get classes() {
    return {
        'is-top-middle': this.position == ContextButtonPosition.TopMiddle,
        'is-bottom-right': this.position == ContextButtonPosition.bottomRight,
        'is-fluent': this.isFluent,
        'is-disabled': this.disabled
    }
  }

  get contextStyles() {
      if (this.shift > 0) {
          return {
              left: `calc(50% - ${this.shift + 4}px)`
          }
      }

      return {};
  }

  @Watch('disabled')
  onDisabledChanged() {
      if (this.disabled && this.showContext) {
          this.hide();
      }
  }

  show() {
    if (this.disabled || this.disableClick) {
        return;
    }

    if (this.buttonMode) {
        this.$emit('clicked');
        return;
    }

    if (!this.showContext) {
      this.showContext = true;
      this.attachHideHandler();
    }

    this.shift = 0;

    this.$nextTick(() => {
       this.adjust();
    });
  }

  adjust() {
      const rect = (this.$refs['context'] as ContextMenu)?.$el?.getBoundingClientRect();
      if (!rect) { return; }

      if (rect.right <= (window.innerWidth || document.documentElement.clientWidth)) { return; }

      this.shift = rect.right - (window.innerWidth || document.documentElement.clientWidth);
  }

  hide() {
    this.showContext = false;
    this.detachHideHandler();
  }

  attachHideHandler() {
    setTimeout(() => {
      document.addEventListener('click', this.hide);
    },5);
  }

  detachHideHandler() {
    document.removeEventListener('click', this.hide);
  }

  OnContextClick(event: MouseEvent) {
    event.stopImmediatePropagation();
    if (this.hideAfterSelect) {
        this.hide();
    }
  }

  destroyed() {
    this.detachHideHandler();
  }
}
